import OldLogInPage from "#shared/auth/login/login-page.tsx";
import {useNewRegistrationFlowFeature} from "#shared/auth/utils/use-new-registration-flow-feature.ts";

import {withStrings} from "./locales/login-splitter/load-strings.tsx";
import NewLogInPage from "./log-in-page.tsx";

// TODO: Remove this component and replace it in auth-routes.tsx
// once we've rolled out the new signup flow to all users
const LoginSplitter = () => {
    return useNewRegistrationFlowFeature() ? (
        <NewLogInPage />
    ) : (
        <OldLogInPage />
    );
};

export default withStrings(LoginSplitter);
